import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { Logo } from './Logo';
const links = [{
  name: 'Home',
  path: '/'
}, {
  name: 'About',
  path: '/about'
}, {
  name: 'Services',
  path: '/services'
}, {
  name: 'Contact',
  path: '/contact'
}];
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Close mobile menu on route change
  useEffect(() => {
    setIsOpen(false);
  }, [location]);
  return <nav className={`sticky top-0 z-50 w-full transition-all duration-300 ${scrolled ? 'bg-black/90 backdrop-blur-md py-2 shadow-lg' : 'bg-black py-4'}`} data-id="element-120" data-mp="1l09kwav50trr">
      <div className="max-w-7xl mx-auto px-4 md:px-8 flex justify-between items-center" data-id="element-121" data-mp="enkeebaq05kp">
        {/* Logo */}
        <Link to="/" className="relative z-50 inline-flex p-1.5 bg-black border border-white/80 rounded-sm" aria-label="Sinclair Development home" data-id="element-122" data-mp="jmx3z3sz7qqz">
          <Logo className="h-14 md:h-[72px]" data-id="element-123" data-mp="3n3dyt186a171" />
        </Link>

        {/* Desktop Nav */}
        <div className="hidden lg:flex items-center gap-8" data-id="element-124" data-mp="3n1jcpjl6031d">
          {links.map(link => <Link key={link.path} to={link.path} className="relative group py-2" data-id="element-125" data-mp="3s049ta54e6ll">
              <span className={`text-sm uppercase tracking-widest font-medium transition-colors duration-300 ${location.pathname === link.path ? 'text-[#C5A55A]' : 'text-gray-300 group-hover:text-white'}`} data-id="element-126" data-mp="5n4ch69ml6hy">
                {link.name}
              </span>
              <span className={`absolute bottom-0 left-0 w-full h-[2px] bg-[#C5A55A] transform origin-left transition-transform duration-300 ${location.pathname === link.path ? 'scale-x-100' : 'scale-x-0 group-hover:scale-x-100'}`} data-id="element-127" data-mp="31aro2s1u37gv" />
            </Link>)}
        </div>

        {/* Mobile Menu Button */}
        <button className="lg:hidden text-white p-2 z-50" onClick={() => setIsOpen(!isOpen)} aria-label="Toggle menu" data-id="element-128" data-mp="362i33bbpujem">
          {isOpen ? <X className="w-6 h-6" data-id="element-129" data-mp="2de471146tx5p" /> : <Menu className="w-6 h-6" data-id="element-130" data-mp="2devqjdkig4fm" />}
        </button>

        {/* Mobile Nav Overlay */}
        <AnimatePresence data-id="element-131" data-mp="2sbcyrvxel2xy">
          {isOpen && <motion.div initial={{
          opacity: 0,
          y: -20
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -20
        }} className="fixed inset-0 bg-black z-40 flex flex-col items-center justify-center lg:hidden" data-id="element-132" data-mp="2nbic64knuzip">
              <div className="flex flex-col items-center gap-6" data-id="element-133" data-mp="f45al1wpjclg">
                {links.map(link => <Link key={link.path} to={link.path} className={`text-xl uppercase tracking-widest font-serif ${location.pathname === link.path ? 'text-[#C5A55A]' : 'text-white'}`} data-id="element-134" data-mp="155mpwh0r1qc">
                    {link.name}
                  </Link>)}
              </div>
            </motion.div>}
        </AnimatePresence>
      </div>
    </nav>;
}